/*!
 * Copyright © 2018-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import { routerReducer } from '@ngrx/router-store';
import { ActionReducerMap } from '@ngrx/store';

import { managePostedSpeedReducer } from '../../../manage-posted-speed/store';
import { replayReducer } from '../../../replay/store';
import { searchReducer } from '../../../search/store';
import { IAppState } from '../state';
import { advancedOptionsReducer } from './advanced-options.reducer';
import { assetsReducer } from './assets.reducer';
import { attributeReducer } from './attribute.reducer';
import { balloonInfoReducer } from './balloon-info.reducer';
import { customerMetadataReducer } from './customer-metadata.reducer';
import { deviceHealthCheckReducer } from './device-health-check.reducer';
import { deviceHealthReducer } from './device-health.reducer';
import { driverMessageReducer } from './driver-message.reducer';
import { ecmPanelReducer } from './ecm-panel.reducer';
import { garminStopHistoryReducer } from './garmin-stop-history.reducer';
import { harshDrivingEventsReducer } from './harsh-driving-events.reducer';
import { layoutPreferencesReducer } from './layout-preferences.reducer';
import { layoutReducer } from './layout.reducer';
import { mapOptionsReducer } from './map-options.reducer';
import { mapsReducer } from './maps.reducer';
import { modulesReducer } from './modules.reducer';
import { plotsReducer } from './plots.reducer';
import { reverseGeocodeReducer } from './reverse-geocode.reducer';
import { roadsideAssistanceReducer } from './roadside-assistance.reducer';
import { sendToGarminReducer } from './send-to-garmin.reducer';
import { sidePanelReducer } from './side-panel.reducer';
import { userMapSettingsReducer } from './user-map-settings.reducer';
import { vehicleDriverPanelReducer } from './vehicle-driver-panel.reducer';
import { vehicleListPanelReducer } from './vehicle-list-panel.reducer';
import { vehicleReducer } from './vehicle.reducer';
import { videoDeviceInfoReducer } from './video-device-info.reducer';
import { workOrderReducer } from './work-order.reducer';
import { workingTimeDirectiveReducer } from './working-time-directive.reducer';

export const appReducers: ActionReducerMap<IAppState, any> = {
  router: routerReducer,
  customerMetadata: customerMetadataReducer,
  layout: layoutReducer,
  layoutPreferences: layoutPreferencesReducer,
  plots: plotsReducer,
  userMapSettings: userMapSettingsReducer,
  mapOptions: mapOptionsReducer,
  vehicleDriverPanel: vehicleDriverPanelReducer,
  advancedOptions: advancedOptionsReducer,
  balloonInfo: balloonInfoReducer,
  vehicle: vehicleReducer,
  maps: mapsReducer,
  vehicleListPanel: vehicleListPanelReducer,
  workingTimeDirective: workingTimeDirectiveReducer,
  driverMessage: driverMessageReducer,
  garminStopHistory: garminStopHistoryReducer,
  sendToGarmin: sendToGarminReducer,
  reverseGeocode: reverseGeocodeReducer,
  workOrder: workOrderReducer,
  roadsideAssistance: roadsideAssistanceReducer,
  harshDrivingEvent: harshDrivingEventsReducer,
  assets: assetsReducer,
  attribute: attributeReducer,
  modules: modulesReducer,
  sidePanel: sidePanelReducer,
  deviceHealthCheck: deviceHealthCheckReducer,
  ecmPanel: ecmPanelReducer,
  videoDeviceInfo: videoDeviceInfoReducer,
  // Replay reducer is needed here to avoid ngrx warnings related to not being able to access a lazy loaded module feature state
  replay: replayReducer,
  search: searchReducer,
  deviceHealth: deviceHealthReducer,
  managePostedSpeed: managePostedSpeedReducer
};
